import type { DisplayExchange } from '../types/displayExchange';
import type { TimelineItem } from '../types/session.types';

/** Séparateur de compaction (restauré ou live) : il structure la conversation, ce n'est pas une réponse. */
function isCompactionSeparatorItem(item: TimelineItem): boolean {
  return item.type === 'tool' && item.event.tool === 'context_compaction';
}

/**
 * Index du dernier échange qui porte un message de l'avocat ou une réponse, ou
 * `-1` s'il n'y en a aucun.
 *
 * Pourquoi pas `exchanges.length - 1` : une compaction manuelle a lieu entre deux
 * tours, donc son marqueur est la DERNIÈRE ligne de l'historique et devient un
 * échange séparateur à part entière (`userMessage: null`). Désigné « dernier », il
 * retirait à la vraie dernière réponse sa barre copier / pouces (visible au seul
 * survol) et ses boutons de navigation d'agent (`onUiAction`), jusqu'au tour suivant.
 */
export function findLastConversationExchangeIndex(exchanges: readonly DisplayExchange[]): number {
  for (let index = exchanges.length - 1; index >= 0; index -= 1) {
    const exchange = exchanges[index];
    if (!exchange) continue;
    if (exchange.userMessage !== null) return index;
    if (exchange.timeline.some((item) => !isCompactionSeparatorItem(item))) return index;
  }
  return -1;
}
